/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartitionsIncreaseResponse
 */
export interface PartitionsIncreaseResponse {
    /**
     * 
     * @type {number}
     * @memberof PartitionsIncreaseResponse
     */
    totalPartitionsCount: number;
    /**
     * 
     * @type {string}
     * @memberof PartitionsIncreaseResponse
     */
    topicName: string;
}

export function PartitionsIncreaseResponseFromJSON(json: any): PartitionsIncreaseResponse {
    return PartitionsIncreaseResponseFromJSONTyped(json, false);
}

export function PartitionsIncreaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartitionsIncreaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalPartitionsCount': json['totalPartitionsCount'],
        'topicName': json['topicName'],
    };
}

export function PartitionsIncreaseResponseToJSON(value?: PartitionsIncreaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalPartitionsCount': value.totalPartitionsCount,
        'topicName': value.topicName,
    };
}

